import { jsx } from "panel";
import { SelectEl } from "../select";
import { SvgIconEl } from "../svg-icon";
import { TagEl } from "../tag";
import { TagSize, TagTheme } from "../tag/types";
import { ButtonEl } from "../button";
import { TagInputTheme } from "./types";
export function template() {
  const isBreadcrumbs = this.attr(`theme`) === TagInputTheme.Breadcrumbs;
  const isLightTheme = this.attr(`theme`) === TagInputTheme.Light;
  const hasNoTags = !this.state.tags.size;
  const showSearchIcon = this.attr(`show-search-icon`) && (hasNoTags || isBreadcrumbs);
  let tagTheme;
  if (isBreadcrumbs) {
    tagTheme = TagTheme.Breadcrumb;
  } else if (this.state.isInputFocused || isLightTheme) {
    tagTheme = TagTheme.Light;
  } else {
    tagTheme = TagTheme.Secondary;
  }
  const tagEls = Array.from(this.state.tags).map((tag) => {
    return /* @__PURE__ */ jsx(TagEl, {
      attrs: {
        removable: this.helpers.canRemoveTag(tag),
        size: TagSize.Small,
        "tag-name": tag.label,
        theme: tagTheme,
        ...tag.attrs
      },
      key: `tag-${tag}`,
      on: { remove: this.helpers.canRemoveTag(tag) && this.helpers.removeTag(tag) }
    });
  });
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-container",
    class: {
      "mp-tag-input-container--white-bg": this.state.isInputFocused,
      [`mp-tag-input-theme-${this.attr(`theme`)}`]: true
    }
  }, showSearchIcon && /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-mp-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `search` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-top-input-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-input-wrapper",
    on: { click: this.helpers.focusInput }
  }, tagEls, /* @__PURE__ */ jsx("input", {
    sel: ".mp-tag-input-search-input",
    attrs: {
      placeholder: this.helpers.getPlaceholder(),
      disabled: this.attr(`disable-input`),
      elref: `mpTagInputSearchInput`
    },
    class: { "mp-tag-input-empty": hasNoTags },
    props: { type: `text`, value: this.state.inputText },
    on: {
      input: this.helpers.setInputText,
      keydown: this.helpers.handleKeyDown,
      focus: this.helpers.onFocusChange,
      blur: this.helpers.onFocusChange
    },
    style: { width: hasNoTags ? `100%` : this.state.inputWidth }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-border",
    class: { "mp-tag-input-error": this.attr(`error`) }
  }))), this.attr(`mp-select-attrs`) && /* @__PURE__ */ jsx(SelectEl, {
    sel: ".mp-tag-input-mp-select",
    attrs: this.helpers.processMpSelectAttrs(),
    on: {
      change: this.helpers.onSelectChange,
      menuChange: this.helpers.onSelectMenuChange
    }
  }), this.attr(`mp-button-attrs`) && /* @__PURE__ */ jsx(ButtonEl, {
    attrs: this.helpers.processMpButtonAttrs(),
    on: {
      click: this.helpers.onButtonPress
    }
  }));
}
